module.exports = __webpack_public_path__ + "img/meli-2023-nov.9d9d8d35.png";